import { render } from "./ChatRoomDropdown.vue?vue&type=template&id=5be31827&scoped=true"
import script from "./ChatRoomDropdown.vue?vue&type=script&lang=js"
export * from "./ChatRoomDropdown.vue?vue&type=script&lang=js"

import "./ChatRoomDropdown.vue?vue&type=style&index=0&id=5be31827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be31827"]])

export default __exports__